import { render, staticRenderFns } from "./PopupIntegral.vue?vue&type=template&id=6a8e6a8c&scoped=true&"
import script from "./PopupIntegral.vue?vue&type=script&lang=js&"
export * from "./PopupIntegral.vue?vue&type=script&lang=js&"
import style0 from "./PopupIntegral.vue?vue&type=style&index=0&id=6a8e6a8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8e6a8c",
  null
  
)

export default component.exports